/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
// import core & vendor Packages below
import axios from 'axios';
import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';

// import Components below
import Filter from './Filter';
import Profile from './Profile';
import Status from 'constant/status';
import DischargeSummaryTable from './Table';
import ConditionalRender from 'components/ConditionalRender';
import FormPatientProfile from 'components/FormPatientProfile';
import { checkStringPermission } from 'helpers/filteredPermissions';

// import assets below
import './index.scss';

// Main Component
const DischargeSummary = () => {
  const [state, setState] = useState([]);
  const [showScreen, setShowScreen] = useState(0);
  const [showProfile, setShowProfile] = useState({
    isModalShow: false,
    isShowView: false,
    profileId: null,
    setActive: '',
  });

  useEffect(() => {
    axios
      .get('/patient', {
        params: {
          patient_status: [Status.FOR_DISCHARGE],
        },
      })
      .then((response) => {
        setState(response.data.data);
      }, [])
      .catch((err) => {
        console.log('AXIOS ERROR: ', err);
      });
  }, []);

  const isDefault = showScreen === 0;
  const isViewProfile = showScreen === 1;
  const isEditProfile = showScreen === 2;

  return (
    <div className='discharge-summary'>
      <ConditionalRender
        condition={isDefault}
        renderIf={
          <>
            <Filter state={state} setState={setState} />

            <DischargeSummaryTable
              state={state}
              setState={setState}
              setShowScreen={setShowScreen}
              setShowProfile={setShowProfile}
            />
          </>
        }
      />

      <ConditionalRender
        condition={isViewProfile}
        renderIf={<Profile showProfile={showProfile} setShowScreen={setShowScreen} />}
      />

      <ConditionalRender
        condition={isEditProfile}
        renderIf={<FormPatientProfile showProfile={showProfile} setShowScreen={setShowScreen} />}
      />
    </div>
  );
};

export default DischargeSummary;
